import React, { useEffect} from 'react';

import { checkString, checkArray } from '../helpers/global';
import BookingLink from './performances/BookingLink';

const Event = props => {

  const {data} = props;
  let img_src = "";
  let img_srcset = "";

  let img_alt = "";
  let focal_point = "";
  let combiStyle = {};
  let fully_booked = false;

  let container_class = "grid-item";

  if (checkArray(data.image_data)){
    img_srcset = data.image_data.toString();
  } else {
    if (data.image_src.length){
      img_src = data.image_src;
    }
  }


  img_alt = data.image_alt;

  if (checkArray(data.focal_point)){
    focal_point = data.focal_point;
     combiStyle = {
      objectPosition: focal_point[0] + "%" + " " + focal_point[1] + "%"
    }
  }


  useEffect(() => {

    if (typeof window.gdVideo != "undefined" ){
      window.gdVideo();
    }
  }, []);

  return (
    <div className={container_class}>
      <div className="slot  event" >
      <div className="slot-top">
      {checkString(data.slot_tag) &&
        <div class={"slot-tag " + `${data.slot_tag_theme}`}>{data.slot_tag}</div>
      }
      {checkString(data.slot_tag_upcoming_name) &&
        <div class={"slot-tag " + `${data.slot_tag_upcoming_class}` }>{data.slot_tag_upcoming_name}</div>
      }
        <a  href={data.url}  className="slot-title font-bold font-xl" dangerouslySetInnerHTML={{__html: data.title}} />
      </div>

       {checkString(img_srcset) &&
         <div className="slot-image">
          <a className="image-container " target={checkString(data.yc_foreign_id) ? '_blank' : '_self'}  href={data.url} >
              <img loading="lazy" srcset={img_srcset}  alt={img_alt} style={combiStyle} />
           </a>
         </div>
       }
       {checkString(img_src) &&
         <div className="slot-image">
          <a className="image-container " target={checkString(data.yc_foreign_id) ? '_blank' : '_self'}  href={data.url} >
              <img loading="lazy" src={img_src}  alt={img_alt} style={combiStyle} />
           </a>
         </div>
       }

        <div className="slot-content">


            {checkString(data.date_formatted) &&
              <div className="slot-date">{data.date_formatted}</div>
            }
            {checkString(data.text) &&
              <div className="slot-text" dangerouslySetInnerHTML={{__html: data.text}} />
            }

        </div>

    </div>
  </div>

  )
}

export default Event;
